require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./service-datascience-quality-assurance.json") })
        }
      }, "path---service-datascience-quality-assurance");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---service-datascience-quality-assurance!./.cache/json/service-datascience-quality-assurance.json
// module id = 897
// module chunks = 231608221292675